/**
 * Jobs
 * Simple tabs for job page
 */

import Tab from './components/_tabs';
Tab.tabs();



// WEBPACK FOOTER //
// ./jobs.js